import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import StepOne from './wizard/StepOne';
import StepTwo from './wizard/StepTwo';
import StepThree from './wizard/StepThree';
import StepFour from './wizard/StepFour';
import SuccessCard from './wizard/SuccessCard';

const PremiumWizard = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [wizardData, setWizardData] = useState({
    selectedGoal: '',
    selectedVideoTypes: [],
    scriptNeeded: '',
    targetAudience: '',
    deadline: '',
    clientName: '',
    clientEmail: '',
    clientPhone: '',
    companyName: '',
    trafficSource: 'Not Selected'
  });
  const [isSubmitted, setIsSubmitted] = useState(false);

  const updateWizardData = (newData) => {
    setWizardData(prev => ({ ...prev, ...newData }));
  };

  const nextStep = () => {
    if (currentStep < 4) {
      setCurrentStep(currentStep + 1);
    }
  };

  const prevStep = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };

  const resetWizard = () => {
    setCurrentStep(1);
    setIsSubmitted(false);
    setWizardData({
      selectedGoal: '',
      selectedVideoTypes: [],
      scriptNeeded: '',
      targetAudience: '',
      deadline: '',
      clientName: '',
      clientEmail: '',
      clientPhone: '',
      companyName: '',
      trafficSource: 'Not Selected'
    });
  };

  const stepVariants = {
    hidden: { opacity: 0, x: 20 },
    visible: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: -20 }
  };

  if (isSubmitted) {
    return <SuccessCard onReset={resetWizard} />;
  }

  return (
    <div className="w-full h-auto bg-[#0a0a0a] flex items-center justify-center p-4">
      <div className="w-full max-w-6xl">
        {/* Step Content */}
        <AnimatePresence mode="wait">
          <motion.div
            key={currentStep}
            variants={stepVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
            transition={{ duration: 0.4, ease: "easeInOut" }}
          >
            {currentStep === 1 && (
              <StepOne 
                selectedGoal={wizardData.selectedGoal} 
                onGoalSelect={(goal) => updateWizardData({ selectedGoal: goal })} 
                onNext={nextStep} 
              />
            )}
            {currentStep === 2 && (
              <StepTwo 
                selectedVideoTypes={wizardData.selectedVideoTypes}
                selectedGoal={wizardData.selectedGoal}
                onVideoTypesChange={(types) => updateWizardData({ selectedVideoTypes: types })}
                onNext={nextStep}
                onPrev={prevStep}
              />
            )}
            {currentStep === 3 && (
              <StepThree 
                wizardData={wizardData}
                updateWizardData={updateWizardData}
                onNext={nextStep}
                onPrev={prevStep}
              />
            )}
            {currentStep === 4 && (
              <StepFour 
                wizardData={wizardData}
                updateWizardData={updateWizardData}
                onPrev={prevStep}
                onSubmit={() => setIsSubmitted(true)}
              />
            )}
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  );
};

export default PremiumWizard;